export const CONFIRMED = 'CONFIRMED';
export const OUTSOURCED = 'OUTSOURCED';

export default [CONFIRMED, OUTSOURCED];
